import { Specialty, SpecialtyPage as HygraphSpecialtyPage } from '@/lib/types';

import { SpecialtyPage } from '@/features/specialty-page';
import { buildDate } from '@/utils/date-utils';

export default function specialtyPageTransformer({
  author,
  estimatedReadingTimeInMinutes,
  hero,
  id,
  modified,
  updatedAt,
  published,
  publishedAt,
  seo,
  specialty,
  specialtyComponents,
  specialityPageSidebar,
  templateSetting,
  title,
  tocEnabled,
}: HygraphSpecialtyPage): SpecialtyPage {
  return {
    __typename: 'SpecialtyPage',
    author: author || null,
    estimatedReadingTimeInMinutes,
    hero: hero || null,
    id,
    modifiedAt: buildDate(modified) ? modified : updatedAt,
    publishedAt: buildDate(published) ? published : publishedAt,
    seo: seo || null,
    specialty: specialty as Specialty,
    components: specialtyComponents,
    sidebar: specialityPageSidebar || null,
    templateSetting: templateSetting || null,
    title: title || specialty?.title || '',
    tocEnabled: tocEnabled || false,
  };
}
